import React, { Component } from 'react';
import ReactTooltip from 'react-tooltip';
import NumberFormat from 'react-number-format';
import logo from './logo.svg';
import './App.css';
import { Chart, Bar } from 'react-chartjs-2';
import {
  Slider,
  SliderInput,
  SliderTrack,
  SliderRange,
  SliderHandle,
  SliderMarker,
} from "@reach/slider";
import "@reach/slider/styles.css";

const sendPostMessage = () => {
  let height = 0;

  if (height !== document.getElementById('risk-calculator-parent').offsetHeight) {
    height = document.getElementById('risk-calculator-parent').offsetHeight;
    window.parent.postMessage({
      frameHeight: height
    }, '*');
    console.log(height);
  }
}

class App extends Component {
  constructor(){
      super();

      sendPostMessage();

      this.state = {
          result: "",
          endpoints: 3000,
          revenue: 600000000,
          businessDays: 250,
          downtimeDays: 10,

          avgEmployeePay: 50000,
          avgAdminPay: 65000,
          timeToRestore: 1,

          sliderMin: 0,
          sliderMax: 100,
          sliderStep: 5,

          alertProbabilityCritical: .01,
          alertProbabilityHigh: .04,
          alertProbabilityMedium: .36,
          alertProbabilityLow: .59,

          alertCoverageCritical: 100,
          alertCoverageHigh: 50,
          alertCoverageMedium: 30,
          alertCoverageLow: 20,

          revenueRisk: 0,
          productivityRisk: 0,
          restorationRisk: 0,
          totalFinancialRisk: 0,

          mitigatedRiskCritical: 0,
          mitigatedRiskHigh: 0,
          mitigatedRiskMedium: 0,
          mitigatedRiskLow: 0,
          mitigatedRiskTotal: 0,
          mitigatedRiskPercent: 0,

          avgWeeklyAlerts: 35000,
          alertsCritical: .001,
          alertsHigh: .009,
          alertsMedium: .29,
          alertsLow: .70,
          alertsFalsePositive: .99,
          alertsEscalated: .001,
          alertsTier12Pay: 70000,
          alertsTier3Pay: 140000,
          alertsAvgTime: 10,

          alertsTier12FTEs: 0,
          alertsTier12Cost: 0,
          alertsTier3FTEs: 0,
          alertsTier3Cost: 0,
          alertsTierFTEsTotal: 0,
          alertsTierCostTotal: 0,

          alertsFalsePositiveNumber: 0,
          alertsFalsePositiveTime: 0,
          alertsEscalatedNumber: 0,
          alertsEscalatedTime: 0,
          alertsNumberTotal: 0,
          alertsTimeTotal: 0,

          showResults: false,
          showResultsComplex: false,
          showResultsComplexToggle: true,

          chartMax: 1000000000,
          data: {
            labels: ['Accepted Risk'],
            datasets: [
              {
                label: 'Accepted Risk',
                data: [19],
                backgroundColor: [
                  'rgba(235, 123, 51, 1)',
                  'rgba(255, 0, 0, 0.2)',
                  'rgba(255, 128, 0, 0.2)',
                  'rgba(255, 99, 132, 0.2)',
                  'rgba(54, 162, 235, 0.2)',
                  'rgba(255, 206, 86, 0.2)',
                  'rgba(75, 192, 192, 0.2)',
                  'rgba(153, 102, 255, 0.2)',
                  'rgba(255, 159, 64, 0.2)',
                ],
                borderColor: [
                  'rgba(235, 123, 51, 1)',
                  'rgba(255, 0, 0, 1)',
                  'rgba(255, 128, 0, 1)',
                  'rgba(255, 99, 132, 1)',
                  'rgba(54, 162, 235, 1)',
                  'rgba(255, 206, 86, 1)',
                  'rgba(75, 192, 192, 1)',
                  'rgba(153, 102, 255, 1)',
                  'rgba(255, 159, 64, 1)',
                ],
                borderWidth: 1,
              }
            ],
          }
      }

      this.updateEndpoints = this.updateEndpoints.bind(this)
      this.updateRevenue = this.updateRevenue.bind(this)
      this.updateBusinessDays = this.updateBusinessDays.bind(this)
      this.updateDowntimeDays = this.updateDowntimeDays.bind(this)
      this.updateAvgWeeklyAlerts = this.updateAvgWeeklyAlerts.bind(this)
      this.updateAvgAlertResTime = this.updateAvgAlertResTime.bind(this)

      this.updateAlertCoverageCritical = this.updateAlertCoverageCritical.bind(this)
      this.updateAlertCoverageHigh = this.updateAlertCoverageHigh.bind(this)
      this.updateAlertCoverageMedium = this.updateAlertCoverageMedium.bind(this)
      this.updateAlertCoverageLow = this.updateAlertCoverageLow.bind(this)

      this.complexToggleHandler = this.complexToggleHandler.bind(this)
      this.complexSelectionHandler = this.complexSelectionHandler.bind(this)

  }

  componentDidMount() {
     var intervalId = setInterval(this.timer, 1000);
     sendPostMessage();
  }

  timer() {
     sendPostMessage();
  }

  componentWillMount() {
    Chart.pluginService.register({
      beforeInit: function(chart, options) {
        chart.legend.afterFit = function() {
          this.height += 15; // must use `function` and not => because of `this`
        };
      }
    });
  }

  updateEndpoints = async (values)  => {
    await this.setState({ endpoints: parseInt(values.value) });
    if (this.state.showResults) this.submitHandler(new Event('build'));
  }

  updateRevenue = async (values)  => {
    await this.setState({ revenue: parseInt(values.value) });
    if (this.state.showResults) this.submitHandler(new Event('build'));
  }

  updateBusinessDays = async (values)  => {
    await this.setState({ businessDays: parseInt(values.value) });
    if (this.state.showResults) this.submitHandler(new Event('build'));
  }

  updateDowntimeDays = async (values)  => {
    await this.setState({ downtimeDays: parseInt(values.value) });
    if (this.state.showResults) this.submitHandler(new Event('build'));
  }

  updateAvgWeeklyAlerts = async (values)  => {
    await this.setState({ avgWeeklyAlerts: parseInt(values.value) });
    this.submitHandler(new Event('build'));
  }

  updateAvgAlertResTime = async (values)  => {
    await this.setState({ alertsAvgTime: parseInt(values.value) });
    this.submitHandler(new Event('build'));
  }

  updateAlertCoverageCritical(values) {
    this.setState({ alertCoverageCritical: parseInt(values) });
    this.submitHandler(new Event('build'));
  }

  updateAlertCoverageHigh(values) {
    this.setState({ alertCoverageHigh: parseInt(values) });
    this.submitHandler(new Event('build'));
  }

  updateAlertCoverageMedium(values) {
    this.setState({ alertCoverageMedium: parseInt(values) });
    this.submitHandler(new Event('build'));
  }

  updateAlertCoverageLow(values) {
    this.setState({ alertCoverageLow: parseInt(values) });
    this.submitHandler(new Event('build'));
  }

  complexToggleHandler = async (event) => {
    event.preventDefault();
    await this.setState({ showResultsComplexToggle: false });
    sendPostMessage();
  }

  complexSelectionHandler = async (event, value) => {
    event.preventDefault();
    if (!value) {
      await this.setState({ showResultsComplexToggle: true });
      const url = '/contact/';
      window.open(url, '_blank');
    }
    await this.setState({ showResultsComplex: value });
    sendPostMessage();
  }

  submitHandler = async (event) => {
    event.preventDefault();

    if (parseInt(this.state.revenue) <= 0 || this.state.revenue === undefined) {
      alert('Revenue must be greater than 0!');
    } else {

      await this.setState({ revenueRisk: this.state.revenue / this.state.businessDays * this.state.downtimeDays });
      await this.setState({ productivityRisk: ( this.state.endpoints * this.state.avgEmployeePay ) / this.state.businessDays * this.state.downtimeDays });
      await this.setState({ restorationRisk: this.state.endpoints * (this.state.avgAdminPay / this.state.businessDays / 8 ) * this.state.timeToRestore });
      await this.setState({ totalFinancialRisk: this.state.revenueRisk + this.state.productivityRisk  }); //+ this.state.restorationRisk });

      await this.setState({ mitigatedRiskCritical: this.state.totalFinancialRisk * (this.state.alertCoverageCritical / 100) * this.state.alertProbabilityCritical});
      await this.setState({ mitigatedRiskHigh: this.state.totalFinancialRisk * (this.state.alertCoverageHigh / 100) * this.state.alertProbabilityHigh});
      await this.setState({ mitigatedRiskMedium: this.state.totalFinancialRisk * (this.state.alertCoverageMedium / 100) * this.state.alertProbabilityMedium});
      await this.setState({ mitigatedRiskLow: this.state.totalFinancialRisk * (this.state.alertCoverageLow / 100) * this.state.alertProbabilityLow});

      await this.setState({ totalAcceptedRisk: this.state.totalFinancialRisk - this.state.mitigatedRiskCritical - this.state.mitigatedRiskHigh - this.state.mitigatedRiskMedium - this.state.mitigatedRiskLow });

      await this.setState({ mitigatedRiskTotal: this.state.totalFinancialRisk - this.state.totalAcceptedRisk });
      await this.setState({ mitigatedRiskPercent: Math.ceil( ( 1 - ( this.state.totalAcceptedRisk / this.state.totalFinancialRisk )) * 100 ) });

      // Old Calcs
      // await this.setState({ alertsFalsePositiveNumber: Math.ceil( (this.state.avgWeeklyAlerts * this.state.alertsCritical * (this.state.alertCoverageCritical / 100) + this.state.avgWeeklyAlerts * this.state.alertsHigh * (this.state.alertCoverageHigh / 100) + this.state.avgWeeklyAlerts * this.state.alertsMedium * (this.state.alertCoverageMedium / 100) + this.state.avgWeeklyAlerts * this.state.alertsLow  * (this.state.alertCoverageLow / 100)) * this.state.alertsFalsePositive ) });
      // await this.setState({ alertsEscalatedNumber: Math.ceil( (this.state.avgWeeklyAlerts * this.state.alertsCritical * (this.state.alertCoverageCritical / 100) + this.state.avgWeeklyAlerts * this.state.alertsHigh * (this.state.alertCoverageHigh / 100) + this.state.avgWeeklyAlerts * this.state.alertsMedium * (this.state.alertCoverageMedium / 100) + this.state.avgWeeklyAlerts * this.state.alertsLow  * (this.state.alertCoverageLow / 100)) * this.state.alertsEscalated ) });
      // New Calcs
      await this.setState({ alertsFalsePositiveNumber: Math.ceil( (this.state.avgWeeklyAlerts * .9994))  });
      await this.setState({ alertsEscalatedNumber: Math.ceil( (this.state.avgWeeklyAlerts * this.state.alertsCritical * (this.state.alertCoverageCritical / 100) + this.state.avgWeeklyAlerts * this.state.alertsHigh * (this.state.alertCoverageHigh / 100) + this.state.avgWeeklyAlerts * this.state.alertsMedium * (this.state.alertCoverageMedium / 100) + this.state.avgWeeklyAlerts * this.state.alertsLow  * (this.state.alertCoverageLow / 100)) * this.state.alertsEscalated ) });

      await this.setState({ alertsNumberTotal: this.state.alertsFalsePositiveNumber  + this.state.alertsEscalatedNumber});

      await this.setState({ alertsFalsePositiveTime: Math.ceil(this.state.alertsFalsePositiveNumber * (this.state.alertsAvgTime / 60))});
      await this.setState({ alertsEscalatedTime: Math.ceil(this.state.alertsEscalatedNumber * (this.state.alertsAvgTime / 60))});
      await this.setState({ alertsTimeTotal: this.state.alertsFalsePositiveTime  + this.state.alertsEscalatedTime });

      if (this.state.alertsFalsePositiveTime / 40 < 1) {
        await this.setState({ alertsTier12FTEs: 1 });
      } else {
        await this.setState({ alertsTier12FTEs: Math.ceil(this.state.alertsFalsePositiveTime / 40) });
      }
      await this.setState({ alertsTier12Cost: Math.ceil(this.state.alertsTier12FTEs * this.state.alertsTier12Pay) });

      if (this.state.alertsEscalatedTime / 40 < 1) {
        await this.setState({ alertsTier3FTEs: 1 });
      } else {
        await this.setState({ alertsTier3FTEs: Math.ceil(this.state.alertsEscalatedTime / 40) });
      }
      await this.setState({ alertsTier3Cost: Math.ceil(this.state.alertsTier3FTEs * this.state.alertsTier3Pay) });

      await this.setState({ alertsTierFTEsTotal: this.state.alertsTier12FTEs + this.state.alertsTier3FTEs });
      await this.setState({ alertsTierCostTotal: this.state.alertsTier12Cost + this.state.alertsTier3Cost });

      const currentChartData = Object.assign({}, this.state.data);
      //currentChartData.datasets[0].data = new Array((this.state.totalFinancialRisk - this.state.totalAcceptedRisk));
      //currentChartData.datasets[0].data = [(this.state.totalFinancialRisk - this.state.totalAcceptedRisk)];
      currentChartData.datasets[0].data = [this.state.totalAcceptedRisk];

      await this.setState({ chartMax: this.state.totalFinancialRisk });

      //currentChartData.labels  = new Array('test');
      await this.setState({ data: currentChartData });

      this.setState({ showResults: true });

      sendPostMessage();
    }
  }

  renderResults() {
    return (
            <div>

               <br />
              <div class="pl-6 pr-6 pt-0 pb-3 bg-white grid grid-cols-1 md:grid-cols-2 gap-4">
                <h3 style={{textAlign: "left"}}>Risk Analysis</h3>
              </div>


              <div class="pl-6 pr-6 pb-6 bg-white grid grid-cols-1 md:grid-cols-2 gap-4">
                <div class="col-span-1">
                  <div id="chartjs">
                    <Bar
                      data={this.state.data}
                      width={100}
                      height={100}
                      options={{
                        maintainAspectRatio: false,
                        scaleLabel: function(label){return  '$' + label.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");},
                        tooltips: {
                            callbacks: {
                                label: function(tooltipItem, data) {
                                    return "$" + Number(tooltipItem.yLabel).toFixed(0).replace(/./g, function(c, i, a) {
                                        return i > 0 && c !== "." && (a.length - i) % 3 === 0 ? "," + c : c;
                                    });
                                }
                            }
                        },
                        scales: {
                          yAxes: [{
                            stacked: true,
                            ticks: {
                              beginAtZero: true,
                              min: 0,
                              max: this.state.chartMax,
                              callback: function(value, index, values) {
                                if(parseInt(value) >= 1000){
                                  return '$' + value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                                } else {
                                  return '$' + value;
                                }
                              }
                            }
                          }],
                          xAxes: [{
                            stacked: true,
                          }]
                        },
                        legend: {
                            display: true,
                            onClick: (e) => e.stopPropagation(),
                            labels: {
                              padding: 10 //default is 10
                            },
                        },
                        plugins: [{
                          afterFit: function(chart, options) {
                            console.log('test');
                            chart.plugins.register({
                              afterFit: function() {
                                this.height = this.height + 150;
                              },
                            })
                          },
                        }]
                      }}
                    />
                  </div>

                  <div class="cs-text">
                      <p><br />Based on our calculations, your SOC is mitigating&nbsp;
                        <strong style={{fontWeight: 700}}><NumberFormat
                        displayType={'text'}
                        value={Math.round(this.state.mitigatedRiskTotal)}
                        thousandSeparator={true}
                        prefix={'$'}
                        /></strong> of financial risk.  However, unresolved alerts are leaving you with <strong style={{fontWeight: 700}}>
                        <NumberFormat
                        displayType={'text'}
                        value={Math.round(this.state.totalAcceptedRisk)}
                        thousandSeparator={true}
                        prefix={'$'}
                        /></strong> of accepted risk. <br /><span style={{fontSize: "12px"}}>*Based on 250 business days and 10 days of estimated attacker downtime.​</span>  </p>
                  </div>
                </div> {/* -- .col-span-1 -- */}

                <div class="col-span-1 pl-6 pr-6">

                <div class="pt-6 pb-2 text-center cs-text">
                  <p>Adjust sliders for percentage of alerts your team investigates and resolves.<br />&nbsp;​</p>
                </div>


                <div class="pb-2 text-left cs-text">
                      <span data-tip data-for='pct_critical' style={{color: "#0099D9", width: "15px", height: "15px", display: "inline-block"}}><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" /></svg></span>&nbsp;
                      % Critical Alerts Resolved
                      <ReactTooltip id='pct_critical' type='warning' effect='solid' backgroundColor="#0099D9">
                      <span style={{width: "240px", fontWeight: "normal", display: "inline-block"}}>
                        <p>Percent of Critical alerts you currently investigate and resolve. Based on a 6-month CRITICAL<strong style={{fontWeight: 700}}>START</strong> study, 0.1% of all alerts a assigned a Critical priority.</p></span>
                      </ReactTooltip>
                    </div>
                    <SliderInput onChange={this.updateAlertCoverageCritical} defaultValue={parseInt(this.state.alertCoverageCritical)} min={this.state.sliderMin} max={this.state.sliderMax} step={this.state.sliderStep}>
                      <SliderTrack>
                        <SliderRange />
                        <SliderHandle />
                      </SliderTrack>
                    </SliderInput>

                    <div class="pt-2 text-right cs-text">
                      <NumberFormat
                        displayType={'text'}
                        value={this.state.alertCoverageCritical}
                        thousandSeparator={true}
                        suffix={"%"}
                        class="focus:ring-indigo-500 focus:border-indigo-500 flex-1 block w-full sm:text-sm"
                       />
                     </div>

                    <div class="pb-2 text-left cs-text">
                      <span data-tip data-for='pct_high' style={{color: "#0099D9", width: "15px", height: "15px", display: "inline-block"}}><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" /></svg></span>&nbsp;
                      % High Alerts Resolved
                      <ReactTooltip id='pct_high' type='warning' effect='solid' backgroundColor="#0099D9">
                      <span style={{width: "240px", fontWeight: "normal", display: "inline-block"}}>
                        <p>Percent of Critical alerts you currently investigate and resolve. Based on a 6-month CRITICAL<strong style={{fontWeight: 700}}>START</strong> study, 0.9% of all alerts assigned a High priority.</p></span>
                      </ReactTooltip>
                    </div>
                    <SliderInput onChange={this.updateAlertCoverageHigh} defaultValue={parseInt(this.state.alertCoverageHigh)} min={this.state.sliderMin} max={this.state.sliderMax} step={this.state.sliderStep}>
                      <SliderTrack>
                        <SliderRange />
                        <SliderHandle />
                      </SliderTrack>
                    </SliderInput>

                    <div class="pt-2 text-right cs-text">
                      <NumberFormat
                        displayType={'text'}
                        value={this.state.alertCoverageHigh}
                        thousandSeparator={true}
                        suffix={"%"}
                        class="focus:ring-indigo-500 focus:border-indigo-500 flex-1 block w-full sm:text-sm"
                       />
                     </div>

                    <div class="pb-2 text-left cs-text">
                      <span data-tip data-for='pct_medium' style={{color: "#0099D9", width: "15px", height: "15px", display: "inline-block"}}><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" /></svg></span>&nbsp;
                      % Medium Alerts Resolved
                      <ReactTooltip id='pct_medium' type='warning' effect='solid' backgroundColor="#0099D9">
                      <span style={{width: "240px", fontWeight: "normal", display: "inline-block"}}>
                        <p>Percent of Critical alerts you currently investigate and resolve. Based on a 6-month CRITICAL<strong style={{fontWeight: 700}}>START</strong>, study 29% of all alerts assigned a Medium priority.</p></span>
                      </ReactTooltip>
                    </div>
                    <SliderInput onChange={this.updateAlertCoverageMedium} defaultValue={parseInt(this.state.alertCoverageMedium)} min={this.state.sliderMin} max={this.state.sliderMax} step={this.state.sliderStep}>
                      <SliderTrack>
                        <SliderRange />
                        <SliderHandle />
                      </SliderTrack>
                    </SliderInput>

                    <div class="pt-2 text-right cs-text">
                      <NumberFormat
                        displayType={'text'}
                        value={this.state.alertCoverageMedium}
                        thousandSeparator={true}
                        suffix={"%"}
                        class="focus:ring-indigo-500 focus:border-indigo-500 flex-1 block w-full sm:text-sm"
                       />
                     </div>

                    <div class="pb-2 text-left cs-text">
                      <span data-tip data-for='pct_low' style={{color: "#0099D9", width: "15px", height: "15px", display: "inline-block"}}><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" /></svg></span>&nbsp;
                      % Low Alerts Resolved
                      <ReactTooltip id='pct_low' type='warning' effect='solid' backgroundColor="#0099D9">
                      <span style={{width: "240px", fontWeight: "normal", display: "inline-block"}}>
                        <p>Percent of Critical alerts you currently investigate and resolve. Based on a 6-month CRITICAL<strong style={{fontWeight: 700}}>START</strong> study, 70% of all alerts assigned a Low priority.</p></span>
                      </ReactTooltip>
                    </div>
                    <SliderInput onChange={this.updateAlertCoverageLow} defaultValue={parseInt(this.state.alertCoverageLow)} min={this.state.sliderMin} max={this.state.sliderMax} step={this.state.sliderStep}>
                      <SliderTrack>
                        <SliderRange />
                        <SliderHandle />
                      </SliderTrack>
                    </SliderInput>

                    <div class="pt-2 text-right cs-text">
                      <NumberFormat
                        displayType={'text'}
                        value={this.state.alertCoverageLow}
                        thousandSeparator={true}
                        suffix={"%"}
                        class="focus:ring-indigo-500 focus:border-indigo-500 flex-1 block w-full sm:text-sm"
                       />
                      </div>

                </div>
              </div> {/* -- .grid -- */}


              <div class="pl-6 pr-6 pt-6 pb-3 bg-white grid grid-cols-1 md:grid-cols-1 gap-4 text-left cs-text">

                      <h3 style={{textAlign: "left"}}>CRITICAL<strong style={{fontWeight: 700}}>START</strong> MDR doesn’t do risk acceptance. ​</h3>

                      <p>Our proprietary Zero-Trust Analytics Platform (ZTAP) auto-resolves 99.94% of all alerts (false positives).  Our elite SOC team investigates the remaining alerts and escalate only 0.006% of alert to our clients.  ​</p>

                      <p>Stop living with risk acceptance. CRITICAL<strong style={{fontWeight: 700}}>START</strong> reduces risk and response costs to levels unachievable by security teams or traditional MDRs.</p>

              </div>







              <div class="pl-6 pr-6 pt-12 pb-6 bg-white grid grid-cols-1 md:grid-cols-2 gap-4 hidden">
                <h3 style={{textAlign: "left"}}>Cost Analysis – Resolving Every Alert</h3>
              </div>

              <div class="pl-6 pr-6 pb-12 bg-white grid grid-cols-1 md:grid-cols-2 gap-12 hidden">
                <div class="col-span-1">
                  <div class="bg-white grid grid-cols-1 md:grid-cols-1 gap-4">
                    <div class="grid md:grid-cols-3 gap-6">
                      <div class="col-span-full">
                        <label for="avg_weekly_alerts" class="block text-sm font-medium text-gray-700 text-left">
                          <span data-tip data-for='avg_weekly_alerts_info' style={{color: "#0099D9", width: "15px", height: "15px", display: "inline-block"}}><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" /></svg></span>&nbsp;
                          Avg. Weekly Alerts
                        </label>
                        <ReactTooltip id='avg_weekly_alerts_info' type='warning' effect='solid' backgroundColor="#0099D9">
                          <span style={{width: "240px", display: "inline-block"}}>Based on a 6-month CRITICAL<strong style={{fontWeight: 700}}>START</strong> study, an average of 100,000 alerts per client per week are generated when security tools are tuned to collect every alert.</span>
                        </ReactTooltip>
                        <NumberFormat
                          name="avg_weekly_alerts"
                          id="avg_weekly_alerts"
                          defaultValue={this.state.avgWeeklyAlerts}
                          onValueChange={this.updateAvgWeeklyAlerts}
                          thousandSeparator={true}
                          class="focus:ring-indigo-500 focus:border-indigo-500 flex-1 block w-full sm:text-sm"
                         />
                      </div>
                    </div>
                  </div>
                </div> {/* -- .col-span-1 -- */}
                <div class="col-span-1">
                  <div class="bg-white grid grid-cols-1 md:grid-cols-1 gap-4">
                    <div class="grid grid-cols-3 gap-6">
                      <div class="col-span-full">
                        <label for="avg_alert_res_time" class="block text-sm font-medium text-gray-700 text-left">
                          <span data-tip data-for='avg_alert_res_time_info' style={{color: "#0099D9", width: "15px", height: "15px", display: "inline-block"}}><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" /></svg></span>&nbsp;
                          Avg. investigation and resolution time (mins)
                        </label>
                        <ReactTooltip id='avg_alert_res_time_info' type='warning' effect='solid' backgroundColor="#0099D9">
                          <span style={{width: "240px", display: "inline-block"}}>The average time for an experienced SOC Analysts to investigate and resolve and alert.</span>
                        </ReactTooltip>
                        <NumberFormat
                          name="avg_alert_res_time"
                          id="avg_alert_res_time"
                          defaultValue={this.state.alertsAvgTime}
                          onValueChange={this.updateAvgAlertResTime}
                          thousandSeparator={true}
                          class="focus:ring-indigo-500 focus:border-indigo-500 flex-1 block w-full sm:text-sm"
                          />
                      </div>
                    </div>
                  </div>
                </div> {/* -- .col-span-1 -- */}
              </div>

              <div class="pl-6 pr-6 pb-12 bg-white grid grid-cols-1 md:grid-cols-2 gap-12 hidden">
                <div class="col-span-1">
                  <div class="bg-white grid grid-cols-1 md:grid-cols-1 gap-8">
                    <div class="grid grid-cols-3 gap-8">


                      <div class="col-span-full">
                      <div style={{overflowX: "auto"}}>
                      <div style={{minWidth: "480px"}}>


                        <div class="grid grid-cols-4 gap-6 pb-2">
                          <div class="text-left cs-text col-span-2">

                          </div>
                          <div class="text-right cs-text">
                             Without CRITICAL<strong style={{fontWeight: 700}}>START</strong>
                          </div>
                          <div class="text-right cs-text">
                             With CRITICAL<strong style={{fontWeight: 700}}>START</strong>
                          </div>
                        </div>


                        <div class="grid grid-cols-4 gap-6 pb-2">
                          <div class="text-left cs-text col-span-2">
                            False positives requiring investigations
                          </div>
                          <div class="text-right cs-text">
                             <NumberFormat
                              displayType={'text'}
                              value={Math.round(this.state.alertsFalsePositiveNumber)}
                              thousandSeparator={true}
                              class="focus:ring-indigo-500 focus:border-indigo-500 flex-1 block w-full sm:text-sm"
                              />
                          </div>
                          <div class="text-right cs-text">
                             0
                          </div>
                        </div>


                        <div class="grid grid-cols-4 gap-6 pb-2">
                          <div class="text-left cs-text col-span-2">
                            Tier1/2 Analysts required
                          </div>
                          <div class="text-right cs-text">
                             <NumberFormat
                              displayType={'text'}
                              value={Math.round(this.state.alertsTier12FTEs)}
                              thousandSeparator={true}
                              class="focus:ring-indigo-500 focus:border-indigo-500 flex-1 block w-full sm:text-sm"
                              />
                          </div>
                          <div class="text-right cs-text">
                             0
                          </div>
                        </div>


                        <div class="grid grid-cols-4 gap-6 pb-2">
                          <div class="text-left cs-text col-span-2">
                            Alerts requiring Tier 3 escalation
                          </div>
                          <div class="text-right cs-text">
                             <NumberFormat
                              displayType={'text'}
                              value={Math.round(this.state.avgWeeklyAlerts * .0006)}
                              thousandSeparator={true}
                              class="focus:ring-indigo-500 focus:border-indigo-500 flex-1 block w-full sm:text-sm"
                              />
                          </div>
                          <div class="text-right cs-text">
                             <NumberFormat
                              displayType={'text'}
                              value={Math.round(this.state.avgWeeklyAlerts * .00006)}
                              thousandSeparator={true}
                              class="focus:ring-indigo-500 focus:border-indigo-500 flex-1 block w-full sm:text-sm"
                              />
                          </div>
                        </div>

                        <div class="grid grid-cols-4 gap-6 pb-2 border-t-2">
                          <div class="text-left col-span-2">
                            <strong>Staffing costs to resolve all alerts</strong>
                          </div>
                          <div class="text-right cs-text">
                             <NumberFormat
                              displayType={'text'}
                              value={Math.round(this.state.alertsTierCostTotal)}
                              thousandSeparator={true}
                              prefix={"$"}
                              class="focus:ring-indigo-500 focus:border-indigo-500 flex-1 block w-full sm:text-sm"
                              />
                          </div>
                          <div class="text-right cs-text">
                             <NumberFormat
                              displayType={'text'}
                              value={Math.round(this.state.alertsTier3Pay * Math.ceil(this.state.avgWeeklyAlerts * this.state.alertsEscalated * this.state.alertsAvgTime / 60 / 40))}
                              thousandSeparator={true}
                              prefix={"$"}
                              class="focus:ring-indigo-500 focus:border-indigo-500 flex-1 block w-full sm:text-sm"
                              />
                          </div>
                        </div>

                      </div>
                      </div>
                      </div> {/* -- overflow -- */}
                    </div>
                  </div>
                </div> {/* -- .col-span-1 -- */}


                <div class="col-span-1">
                  <div class="text-left cs-text">
                    <p>CRITICAL<strong style={{fontWeight: 700}}>START</strong> reduces risk and detection and response costs unachievable by security team or traditional MDRs.</p><br />
                    <p>False positives create the biggest barrier to resolving all alerts and reducing risk acceptance to near zero. ZTAP auto-resolution of false positives reduces the need to build out large Tier 1 and 2 analyst teams.  Reduced alert escalation eliminates alert fatigue and frees your Tier 3 analysts for other high priority projects.</p><br />
                  </div>

                </div> {/* -- .col-span-1 -- */}

              </div>









              <div class="whitepaper">
                <div class="mt-8 pl-6 pr-6 grid grid-cols-1 lg:grid-cols-2 gap-12">
                  <div class="pt-12 pb-8 text-left">
                    <h1 class="text-left">Q: How much risk should you accept?</h1>
                    <h2 class="text-left">A: None</h2>

                    <p class="pt-5 cs-text">Discover the financial consequences of risk acceptance.  </p>

                    <br />
                    <a class="text-left el-content uk-button uk-button-primary" href="/risk-assessment/" target="_blank" style={{marginRight: "20px"}}>Download the Whitepaper</a>

                    <a class="text-left el-content uk-button uk-button-primary" href="/contact/free-assessment/" target="_blank">Free Assessment</a>


                  </div>

                  <div>
                    <img class="img" alt="" src="https://cswpenginedev.wpengine.com/wp-content/uploads/2021/02/financial-consequence-min.png" />
                  </div>
                </div>
              </div>

              <div class="pl-6 pr-6 pb-6 bg-white grid grid-cols-1 md:grid-cols-1 gap-12">
                <div class="col-span-1">
                  <div class="bg-white grid grid-cols-1 md:grid-cols-1 gap-4 cs-text text-left">

                      <p>Stop living with risk acceptance.</p>

                      <p>
                        <a class="el-content uk-button uk-button-text" href="/contact/" target="_blank">Contact an MDR expert today
                        </a>
                       </p>

                  </div>
                </div> {/* -- .col-span-1 -- */}

              </div>

            </div>
    )
  }

  renderInitialFilters() {
    return (
            <form onSubmit={this.submitHandler}>
              <div class="sm:overflow-hidden">
                <div class="px-4 py-5 bg-white sm:p-6 grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div class="grid md:grid-cols-3 gap-6">
                    <div class="col-span-full">
                      <label for="endpoints" class="block text-sm font-medium text-gray-700 text-left">
                        <span data-tip data-for='endpoints_info' style={{color: "#0099D9", width: "15px", height: "15px", display: "inline-block"}}><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" /></svg></span>&nbsp;
                        Employees
                      </label>
                      <ReactTooltip id='endpoints_info' type='warning' effect='solid' backgroundColor="#0099D9">
                        <span style={{width: "240px", display: "inline-block"}}>The number of employees who cannot perform their duties due to interruption of business operations</span>
                      </ReactTooltip>
                      <NumberFormat
                        name="endpoints"
                        id="endpoints"
                        defaultValue={this.state.endpoints}
                        onValueChange={this.updateEndpoints}
                        thousandSeparator={true}
                        class="focus:ring-indigo-500 focus:border-indigo-500 flex-1 block w-full sm:text-sm"
                       />
                    </div>
                  </div>

                  <div class="grid grid-cols-3 gap-6">
                    <div class="col-span-full">
                      <label for="revenue" class="block text-sm font-medium text-gray-700 text-left">
                        <span data-tip data-for='revenue_info' style={{color: "#0099D9", width: "15px", height: "15px", display: "inline-block"}}><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" /></svg></span>&nbsp;
                        Annual Revenue
                      </label>
                      <ReactTooltip id='revenue_info' type='warning' effect='solid' backgroundColor="#0099D9">
                        <span style={{width: "240px", display: "inline-block"}}>The annual revenues at risk due to interruption of business operations</span>
                      </ReactTooltip>
                      <NumberFormat
                        name="revenue"
                        id="revenue"
                        defaultValue={this.state.revenue}
                        onValueChange={this.updateRevenue}
                        thousandSeparator={true}
                        prefix={'$'}
                        class="focus:ring-indigo-500 focus:border-indigo-500 flex-1 block w-full sm:text-sm"
                        />
                    </div>
                  </div>
                </div>



                <div class="px-4 py-3 text-right sm:px-6">
                  <button type="submit" class="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white focus:outline-none">
                    { this.state.showResults ? 'Update' : 'Submit' }
                  </button>
                </div>
                </div>
             </form>
    )
  }

  render() {
    return (
    <div className="App" id="risk-calculator">

      <div>{ this.state.result}

        { this.state.showResults == 3 ? this.renderInitialFilters() : null }

        { this.state.showResults ? this.renderResults() : this.renderInitialFilters() }

      </div>

    </div>
    );
  }
}

export default App;
